import { ReactNode } from "react";

import { RVRow } from "../../../../layouts/RVFlexbox/RVFlexbox";

export type RVModalFooterProps = {
    /** Buttons rendered on the left side of the footer, they'll already be aligned and spaced */
    leftButtons?: ReactNode;
    /** Buttons rendered on the right side of the footer, they'll already be aligned and spaced */
    rightButtons?: ReactNode;
};

/**
 * Custom footer for an RVModal. Must use whenever the footer requires more than just the standard confirm and cancel buttons.
 */
export function RVModalFooter({ leftButtons, rightButtons }: RVModalFooterProps): JSX.Element {
    return (
        <RVRow justifyContent="space-between" alignItems="center">
            <RVRow alignItems="center" gap={2}>
                {leftButtons}
            </RVRow>
            <RVRow alignItems="center" gap={2}>
                {rightButtons}
            </RVRow>
        </RVRow>
    );
}
